import { useMatch } from 'react-router';
import { IndependentIraOpenOrders, IraUserOpenOrders } from 'screens';
import {
  ROUTE_CONTRIBUTION_DETAIL_IRA_ACCOUNT_OPEN_ORDERS,
  ROUTE_CONTRIBUTION_DETAIL_IRA_USER_OPEN_ORDERS,
} from 'constants/routes';

const ContributionDetailUserOpenOrders = (): JSX.Element => {
  const isIRAUser = useMatch(ROUTE_CONTRIBUTION_DETAIL_IRA_USER_OPEN_ORDERS);
  const isIRAAccount = useMatch(ROUTE_CONTRIBUTION_DETAIL_IRA_ACCOUNT_OPEN_ORDERS);

  if (isIRAUser) {
    return <IraUserOpenOrders />;
  }
  if (isIRAAccount) {
    return <IndependentIraOpenOrders />;
  }
  return <></>;
};

export default ContributionDetailUserOpenOrders;
